import * as React from "react";

const MenuIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <g fill="#5D6B7F" clipPath="url(#clip0_755_2861)">
      <path d="M8.83 20.83A3.173 3.173 0 0 0 12 24a3.173 3.173 0 0 0 3.17-3.17A3.173 3.173 0 0 0 12 17.66a3.174 3.174 0 0 0-3.17 3.17M8.83 11.845a3.173 3.173 0 0 0 3.17 3.17 3.173 3.173 0 0 0 3.17-3.17A3.173 3.173 0 0 0 12 8.675a3.174 3.174 0 0 0-3.17 3.17M8.83 3.17A3.174 3.174 0 0 0 12 6.34a3.173 3.173 0 0 0 3.17-3.17A3.173 3.173 0 0 0 12 0a3.174 3.174 0 0 0-3.17 3.17"></path>
    </g>
    <defs>
      <clipPath id="clip0_755_2861">
        <path fill="#fff" d="M0 24V0h24v24z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default MenuIcon;
